/**
 * FHIR Reference Builder
 *
 * Utility for generating FHIR resource references (Patient, Practitioner, Appointment). Provides consistent reference
 * formatting across services.
 */

/**
 * Builds a reference to a FHIR Patient resource Falls back to member-based reference if resource ID not available
 *
 * @param patient - Patient resource with optional id
 * @param memberId - Fallback member ID
 * @returns Reference string like 'Patient/123' or 'Patient/member-456'
 */
export function buildPatientReference(patient?: { id?: string | null } | null, memberId?: number | null): string {
  if (patient?.id) return `Patient/${patient.id}`;
  if (memberId != null) return `Patient/member-${memberId}`;
  return 'Patient/unknown';
}

/**
 * Builds a reference to a FHIR Practitioner resource Falls back to NPI-based references if resource ID not available
 *
 * @param practitioner - Practitioner resource with optional id
 * @param pcp - PCP data with optional npiNumber
 * @param scheduledNpi - Scheduled NPI from appointment
 * @returns Reference string like 'Practitioner/123' or 'Practitioner/npi-456'
 */
export function buildPractitionerReference(
  practitioner?: { id?: string | null } | null,
  pcp?: { npiNumber?: string | null } | null,
  scheduledNpi?: string | null
): string {
  if (practitioner?.id) return `Practitioner/${practitioner.id}`;
  if (pcp?.npiNumber) return `Practitioner/npi-${pcp.npiNumber}`;
  if (scheduledNpi) return `Practitioner/npi-${scheduledNpi}`;
  return 'Practitioner/unknown';
}

export class FhirReferenceBuilder {
  static buildPatientReference = buildPatientReference;
  static buildPractitionerReference = buildPractitionerReference;
}
